import React from "react";
import Skeleton from "../Skeleton/Skeleton";

const PageIntentSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-1 p-4 border border-[var(--color-paper-600)] rounded-md">
      <div className="flex justify-between items-center mb-4">
        <div className="flex flex-col gap-1">
          <Skeleton width={120} height={20} />
          <Skeleton width={240} height={16} />
        </div>
        <Skeleton width={160} height={32} />
      </div>

      <div className="flex justify-between px-4 py-2 border-b border-[var(--color-paper-600)] text-white-500">
        <Skeleton width={120} height={20} />
        <Skeleton width={100} height={20} />
        <Skeleton width={100} height={20} />
      </div>

      {[...Array(3)].map((_, index) => (
        <div
          key={index}
          className="flex justify-between px-4 py-3 border-b border-[var(--color-paper-600)]"
        >
          <Skeleton width={120} height={20} />
          <Skeleton width={70} height={26} />
          <div className="flex">
            <Skeleton width={60} height={26} />
            <Skeleton width={60} height={26} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PageIntentSkeleton;
